import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Button from './Button'
import WarningIcon from './icons/WarningIcon'

const OVERLAY = 'tw:fixed tw:inset-0 tw:flex tw:items-center tw:justify-center tw:p-4'
const PANEL = 'tw:relative tw:bg-white tw:rounded-md! tw:shadow-lg tw:w-full tw:max-w-md'
const BODY = 'tw:flex tw:flex-col tw:items-center tw:gap-4 tw:pt-8 tw:pb-4 tw:px-4 tw:text-center'
const ICON_WRAP = 'tw:flex tw:h-12 tw:w-12 tw:items-center tw:justify-center'
  + ' tw:rounded-lg! tw:bg-ds-progress-lowest'
const FOOTER = 'tw:flex tw:justify-end tw:gap-3 tw:px-4 tw:py-3'
  + ' tw:border-t tw:border-solid tw:border-gray-200'
const CLOSE_BTN = 'tw:absolute tw:top-3 tw:right-3 tw:border-0 tw:bg-transparent'
  + ' tw:cursor-pointer tw:text-gray-400'

const ConfirmDialog = ({
  isOpen, title, message, confirmLabel, confirmVariant, cancelLabel, onConfirm, onCancel, onClose
}) => {
  if (!isOpen)
    return null

  const content = (
    <>
      <div className="tw:fixed tw:inset-0 tw:bg-black/40" style={{ zIndex: 1060 }} />
      <div className={OVERLAY} style={{ zIndex: 1061 }}>
        <div className={PANEL}>
          <button type="button" className={CLOSE_BTN} aria-label="Fermer" onClick={onClose}>
            <i className="fas fa-times" />
          </button>
          <div className={BODY}>
            <div className={ICON_WRAP}>
              <WarningIcon className="tw:h-6 tw:w-6 tw:text-ds-warning" />
            </div>
            <div className="tw:flex tw:flex-col tw:gap-3 tw:w-full">
              <p className="tw:text-base tw:font-medium tw:text-gray-900 tw:m-0!">{title}</p>
              <p className="tw:text-base tw:text-gray-500 tw:m-0!">{message}</p>
            </div>
          </div>
          <div className={FOOTER}>
            <Button variant="neutral" onClick={onCancel}>{cancelLabel}</Button>
            <Button variant={confirmVariant} onClick={onConfirm}>{confirmLabel}</Button>
          </div>
        </div>
      </div>
    </>
  )

  return ReactDOM.createPortal(content, document.body)
}

ConfirmDialog.propTypes = {
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  confirmVariant: PropTypes.oneOf(['primary', 'danger', 'warning']),
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired
}

ConfirmDialog.defaultProps = {
  cancelLabel: 'Annuler',
  confirmLabel: 'Confirmer',
  confirmVariant: 'danger'
}

export default ConfirmDialog
